import buildScreenHeaderItems from '@/components/buildScreenHeaderItems'
import useWebBackButton from '@/lib/hooks/useWebBackButton'
import PayResult from '@/modules/profile/PayResult'
import { Stack } from 'expo-router'
import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'

export default function PayResultPage() {
  const insets = useSafeAreaInsets()
  const headerLeftItems = useWebBackButton('/profile')

  return (
    <View className="flex-1" style={Platform.OS === 'android' ? { paddingBottom: insets.bottom } : undefined}>
      <Stack.Screen options={{ ...buildScreenHeaderItems({ left: headerLeftItems }) }} />
      <PayResult />
    </View>
  )
}
